/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Connect_TitleInputs */

const en_ui_onboarding_connect_title = /** @type {(inputs: Ui_Onboarding_Connect_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect intervals.icu`)
};

const de_ui_onboarding_connect_title = /** @type {(inputs: Ui_Onboarding_Connect_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu verbinden`)
};

/**
* | output |
* | --- |
* | "Connect intervals.icu" |
*
* @param {Ui_Onboarding_Connect_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_connect_title = /** @type {((inputs?: Ui_Onboarding_Connect_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Connect_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_connect_title(inputs)
	return de_ui_onboarding_connect_title(inputs)
});